import { WizardComponentBaseProps } from "../../../../reusable_components/WizardPageController/WizardPageController.utils";
import { FormRecord } from "../../ClientCreator.utils";

export interface ClientDocument {
  ClientDocumentId: number;
  FirmId?: number;
  ClientMasterId: number;
  ClientName?: string;
  FileName: string;
  BlobUrl: string;
  DocumentTypeCode: string;
  DocumentTypeName?: string;
  Status?: string;
  Active?: "Y" | "N";
  CreatedBy?: string;
  CreatedDate?: string; // ISO date string
  UpdatedBy?: string;
  UpdatedDate?: string; // ISO date string
}


/**
 * Interface for the props of `AcceptanceApprovalViewer`.
 */
export interface DocumentUploaderProps {
  fields: any;
  clientMasterId: number;
  disabled?: boolean;
  onValidationChange?: (result: { isValid: boolean; missing: string[] }) => void;
  formFieldsByTab?: any;
}


export const downloadFile = async (url: string, fileName: string) => {
  if (!url) return;

  try {
    const response = await fetch(url, { mode: "cors" });
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName || "document";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("Failed to download file:", err);
  }
};